import { OrderSet } from '@exodus/models';
const orders = (state, payload) => ({
    ...state,
    isLoaded: true,
    data: Array.isArray(payload) ? OrderSet.fromArray(payload) : payload,
});
const eventReducers = { orders };
export default eventReducers;
